var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("el-collapse-transition", [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.show,
            expression: "show",
          },
        ],
      },
      [
        _c(
          "el-row",
          { attrs: { gutter: 60 } },
          [
            _c(
              "el-col",
              { attrs: { span: 8 } },
              [
                _c(
                  "el-form-item",
                  {
                    key: "signBoardBrand_" + (_vm.isBailianFlag ? "by" : ""),
                    staticClass: "form-item-title",
                    attrs: {
                      label: _vm.$t(
                        "retailStoresInfo.form.storeInfoPic.storeSignBrand"
                      ),
                      prop: "signBoardBrand",
                      rules: _vm.rules.chooseEmpty,
                    },
                  },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: {
                          clearable: "",
                          disabled: _vm.type !== "edit",
                          placeholder: _vm.$t(
                            "retailStoresInfo.input.selectHolder"
                          ),
                        },
                        model: {
                          value: _vm.form.signBoardBrand,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "signBoardBrand", $$v)
                          },
                          expression: "form.signBoardBrand",
                        },
                      },
                      _vm._l(
                        _vm.lookupList["STORE_SIGN_BRAND_TYPE"],
                        function (item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: { label: item.name, value: item.code },
                          })
                        }
                      ),
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-col",
              { attrs: { span: 8 } },
              [
                _c(
                  "el-form-item",
                  {
                    key: "installationDate_" + (_vm.isBailianFlag ? "by" : ""),
                    staticClass: "form-item-title",
                    attrs: {
                      label: _vm.$t(
                        "retailStoresInfo.form.storeInfoPic.installationDate"
                      ),
                      prop: "installationDate",
                      rules: _vm.isBailianFlag ? _vm.rules.iptEmpty : null,
                    },
                  },
                  [
                    _c("el-date-picker", {
                      attrs: {
                        type: "date",
                        clearable: "",
                        "value-format": "yyyy-MM-dd",
                        placeholder:
                          _vm.type !== "edit"
                            ? ""
                            : _vm.$t("retailStoresInfo.input.dataHolder"),
                        disabled: _vm.type !== "edit",
                      },
                      model: {
                        value: _vm.form.installationDate,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "installationDate", $$v)
                        },
                        expression: "form.installationDate",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-col",
              { attrs: { span: 8 } },
              [
                _c(
                  "el-form-item",
                  {
                    key: "dueTime_" + (_vm.isBailianFlag ? "by" : ""),
                    staticClass: "form-item-title",
                    attrs: {
                      label: _vm.$t(
                        "retailStoresInfo.form.storeInfoPic.expDate"
                      ),
                      prop: "dueTime",
                      rules: _vm.isBailianFlag ? _vm.rules.iptEmpty : null,
                    },
                  },
                  [
                    _c("el-date-picker", {
                      attrs: {
                        type: "date",
                        clearable: "",
                        "value-format": "yyyy-MM-dd",
                        placeholder:
                          _vm.type !== "edit"
                            ? ""
                            : _vm.$t("retailStoresInfo.input.dataHolder"),
                        disabled: _vm.type !== "edit",
                      },
                      model: {
                        value: _vm.form.dueTime,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "dueTime", $$v)
                        },
                        expression: "form.dueTime",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-col",
              { attrs: { span: 8 } },
              [
                _c(
                  "el-form-item",
                  {
                    key: "otherBrand_" + (_vm.isBailianFlag ? "by" : ""),
                    staticClass: "form-item-title",
                    attrs: {
                      label: _vm.$t(
                        "retailStoresInfo.form.storeInfoPic.otherBrands"
                      ),
                      prop: "otherBrand",
                      rules: _vm.isBailianFlag ? _vm.rules.iptEmpty : null,
                    },
                  },
                  [
                    _c("el-input", {
                      attrs: {
                        maxlength: "10",
                        placeholder:
                          _vm.type !== "edit"
                            ? ""
                            : _vm.$t("retailStoresInfo.input.inputHolder"),
                        clearable: "",
                        disabled: _vm.type !== "edit",
                      },
                      model: {
                        value: _vm.form.otherBrand,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "otherBrand", $$v)
                        },
                        expression: "form.otherBrand",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "el-row",
          { attrs: { gutter: 60 } },
          [
            _c(
              "el-col",
              { attrs: { span: 8 } },
              [
                _c(
                  "el-form-item",
                  {
                    staticClass: "form-item-title",
                    attrs: {
                      label: _vm.$t(
                        "retailStoresInfo.form.storeInfoPic.storefrontPic"
                      ),
                    },
                  },
                  [
                    _c("FormUploadImg", {
                      attrs: {
                        "file-url": _vm.form.photo1,
                        "upload-params": _vm.uploadParams,
                        "footer-text": _vm.photo1HistoryTime,
                        mode: "view",
                      },
                      on: {
                        "update:fileUrl": function ($event) {
                          return _vm.$set(_vm.form, "photo1", $event)
                        },
                        "update:file-url": function ($event) {
                          return _vm.$set(_vm.form, "photo1", $event)
                        },
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-col",
              { attrs: { span: 8 } },
              [
                _c(
                  "el-form-item",
                  {
                    key: "photo2_" + (_vm.isBailianFlag ? "by" : ""),
                    staticClass: "form-item-title",
                    attrs: {
                      label: _vm.$t(
                        "retailStoresInfo.form.storeInfoPic.displayPic1"
                      ),
                      prop: "photo2",
                      rules: _vm.isBailianFlag ? _vm.rules.uploadEmpty : null,
                    },
                  },
                  [
                    _c("FormUploadImg", {
                      attrs: {
                        "file-url": _vm.form.photo2,
                        "upload-params": _vm.uploadParams,
                        "footer-text": _vm.photo2HistoryTime,
                        mode: _vm.type,
                      },
                      on: {
                        "update:fileUrl": function (v) {
                          return _vm.updateFormValue(v, "photo2", _vm.form)
                        },
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-col",
              { attrs: { span: 8 } },
              [
                _c(
                  "el-form-item",
                  {
                    key: "photo3_" + (_vm.isBailianFlag ? "by" : ""),
                    staticClass: "form-item-title",
                    attrs: {
                      label: _vm.$t(
                        "retailStoresInfo.form.storeInfoPic.displayPic2"
                      ),
                      prop: "photo3",
                      rules: _vm.isBailianFlag ? _vm.rules.uploadEmpty : null,
                    },
                  },
                  [
                    _c("FormUploadImg", {
                      attrs: {
                        "file-url": _vm.form.photo3,
                        "upload-params": _vm.uploadParams,
                        "footer-text": _vm.photo3HistoryTime,
                        mode: _vm.type,
                      },
                      on: {
                        "update:fileUrl": function (v) {
                          return _vm.updateFormValue(v, "photo3", _vm.form)
                        },
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }